import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Switch } from "antd";
import { getShortLeaveConfig, updateShortLeaveConfig } from "../../../config/services/employeeServices";
import { Loader } from "../../svg";
import ResponseFilter from "../../../ResponseFilter";
import { Toastify } from "../../helper/Constant";

function ShortLeaveConfigModal(props) {
    const [earnedLeave, setEarnedLeave] = useState(true);
    const [casualLeave, setCasualLeave] = useState(true);
    const [sickLeave, setSickLeave] = useState(true);
    const [lwpLeave, setLwpLeave] = useState(true);
    const [sandwichLeave, setSandwichLeave] = useState({
        enableCasualLeave: false,
        enableEarnedLeave: false,
        enableSickLeave: false,
        enableLwp: false,
        enableCompensatoryOff: false,
        enableWorkFromHome: false,
        enableOtherLeave: false,
        enableClientOff: false,
        enablePaternalLeave: false,
        enableBereavementLeave: false,
    });
    const [monitorAttendance, setMonitorAttendance] = useState({
        enableLateComing: false,
        enableEarlyGoing: false,
    });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [resMsg, setResMsg] = useState(false);
    const [resMsgFail, setResMsgFail] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [responseMessage, setResponseMessage] = useState("");

    useEffect(() => {
        if (props.show) {
            fetchConfig();
        }
    }, [props.show]);

    const fetchConfig = () => {
        setLoading(true);
        getShortLeaveConfig()
            .then((res) => {
                if (res.data.statusCode === 1) {
                    const config = res.data.responseData.list;
                    setEarnedLeave(config.enableEarnedLeave);
                    setCasualLeave(config.enableCasualLeave);
                    setSickLeave(config.enableSickLeave);
                    setLwpLeave(config.enableLwp);
                    if (config.sandwichLeave) {
                        setSandwichLeave(config.sandwichLeave);
                    }
                    if (config.monitorAttendance) {
                        setMonitorAttendance(config.monitorAttendance);
                    }
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Failed to load config", error);
                setLoading(false);
            });
    };

    const handleSandwichToggle = (key, value) => {
        setSandwichLeave(prev => ({ ...prev, [key]: value }));
    };

    const handleMonitorToggle = (key, value) => {
        setMonitorAttendance(prev => ({ ...prev, [key]: value }));
    };

    const handleSave = () => {
        setSaving(true);
        const params = {
            type: 'short_leave_config',
            enableEarnedLeave: earnedLeave,
            enableCasualLeave: casualLeave,
            enableSickLeave: sickLeave,
            enableLwp: lwpLeave,
            sandwichLeave: sandwichLeave,
            monitorAttendance: monitorAttendance,
        };

        updateShortLeaveConfig(params)
            .then((res) => {
                let { status, resData } = ResponseFilter(res);
                setSaving(false);
                if (status) {
                    setResMsg(true);
                    setSuccessMessage("Configuration updated successfully");
                    setTimeout(() => {
                        setResMsg(false);
                        props.handleClose();
                    }, 2000);
                } else {
                    setResMsgFail(true);
                    setResponseMessage(resData || "Failed to update configuration");
                    setTimeout(() => setResMsgFail(false), 3000);
                }
            })
            .catch((error) => {
                setSaving(false);
                setResMsgFail(true);
                setResponseMessage("Failed to update configuration");
                setTimeout(() => setResMsgFail(false), 3000);
            });
    };

    const sandwichFields = [
        { label: "Casual Leave", key: "enableCasualLeave" },
        { label: "Earned Leave", key: "enableEarnedLeave" },
        { label: "Sick Leave", key: "enableSickLeave" },
        { label: "LWP", key: "enableLwp" },
        { label: "Compensatory Off", key: "enableCompensatoryOff" },
        { label: "WFH", key: "enableWorkFromHome" },
        { label: "Other's Leave", key: "enableOtherLeave" },
        { label: "Client-side Off", key: "enableClientOff" },
        { label: "Parenting Leave", key: "enablePaternalLeave" },
        { label: "Bereavement Leave", key: "enableBereavementLeave" },
    ];

    return (
        <Modal show={props.show} onHide={props.handleClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    <b>Leave Policy Configuration</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <Toastify
                    resMsg={resMsg}
                    resMsgFail={resMsgFail}
                    text={successMessage}
                    responseMessage={responseMessage}
                />
                {loading ? (
                    <div className="text-center d-flex align-items-center justify-content-center" style={{ minHeight: '300px', position: 'relative' }}>
                        <Loader small />
                    </div>
                ) : (
                    <>
                        <div className="container">
                            <h6 className="font-weight-bold text-primary border-bottom pb-2 mb-3">Short Leave Toggles</h6>
                            <p className="text-muted small mb-3">
                                Enable or disable leave types available for Short Leave applications.
                            </p>

                            <div className="row mb-4">
                                <div className="col-md-6 mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <label className="mb-0">Earned Leave (EL)</label>
                                        <Switch checked={earnedLeave} onChange={setEarnedLeave} checkedChildren="ON" unCheckedChildren="OFF" size="small" />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <label className="mb-0">Casual Leave (CL)</label>
                                        <Switch checked={casualLeave} onChange={setCasualLeave} checkedChildren="ON" unCheckedChildren="OFF" size="small" />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <label className="mb-0">Sick Leave (SL)</label>
                                        <Switch checked={sickLeave} onChange={setSickLeave} checkedChildren="ON" unCheckedChildren="OFF" size="small" />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <label className="mb-0">LWP</label>
                                        <Switch checked={lwpLeave} onChange={setLwpLeave} checkedChildren="ON" unCheckedChildren="OFF" size="small" />
                                    </div>
                                </div>
                            </div>

                            <h6 className="font-weight-bold text-primary border-bottom pb-2 mb-3">Sandwich Leave Settings</h6>
                            <p className="text-muted small mb-3">
                                When enabled, applying leave on a day adjacent to a weekend (e.g. Monday or Friday) will include the weekend in deduction if the other side is also a leave.
                            </p>

                            <div className="row">
                                {sandwichFields.map(field => (
                                    <div className="col-md-6 mb-3" key={field.key}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <label className="mb-0">{field.label}</label>
                                            <Switch
                                                checked={sandwichLeave[field.key]}
                                                onChange={(val) => handleSandwichToggle(field.key, val)}
                                                checkedChildren="ON"
                                                unCheckedChildren="OFF"
                                                size="small"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <h6 className="font-weight-bold text-primary border-bottom pb-2 mb-3">Attendance Late/Early Settings</h6>
                            <p className="text-muted small mb-3">
                                Configure attendance rules to be treated as leave.
                            </p>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <label className="mb-0">Late Coming</label>
                                        <Switch
                                            checked={monitorAttendance.enableLateComing}
                                            onChange={(val) => handleMonitorToggle("enableLateComing", val)}
                                            checkedChildren="ON"
                                            unCheckedChildren="OFF"
                                            size="small"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <label className="mb-0">Early Going</label>
                                        <Switch
                                            checked={monitorAttendance.enableEarlyGoing}
                                            onChange={(val) => handleMonitorToggle("enableEarlyGoing", val)}
                                            checkedChildren="ON"
                                            unCheckedChildren="OFF"
                                            size="small"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="text-center mt-4">
                            <button
                                type="button"
                                className="btn btn-primary px-5"
                                onClick={handleSave}
                                disabled={saving}
                                style={{ borderRadius: "20px" }}
                            >
                                {saving ? "Updating..." : "Save Configuration"}
                            </button>
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default ShortLeaveConfigModal;
